import axios from 'axios';
import { LegalForm } from '../models';

export const getLegalForms = () => {
    return axios.get<LegalForm[]>(`LegalForms`);
};
